import { HomeSectionsDataSchema } from "@repo/contracts";

/**
 * Merge a (partial) sections payload from `GET /home?sections=…` into the
 * current home data. Present sections replace their previous value; absent
 * sections are preserved.
 */
export function mergeHomeSectionsState(currentData, partial, now = () => new Date()) {
  const validated = HomeSectionsDataSchema.parse(partial ?? {});
  const data = { ...(currentData || {}) };
  for (const [key, value] of Object.entries(validated)) {
    if (value !== undefined) data[key] = value;
  }
  return {
    data,
    lastUpdated: validated.executiveSummary?.asOfUtc || now().toISOString(),
    error: null,
  };
}
